import template from './customer_pickup_reports.html';
import controller from './customer_pickup_reports.controller';
import './customer_pickup_reports.scss';

let branchManagementCustomerPickupReportsComponent = {
    restrict: "E",
    bindings: {},
    template,
    controller
};

export default branchManagementCustomerPickupReportsComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/customer_pickup_reports/customer_pickup_reports.component.js